<template>
  <ProductSettingsGenericFilter
    v-if="availableLabels?.length > 0"
    :heading="heading"
    :count="selectedValues.length"
  >
    <div class="options">
      <Checkbox
        v-for="label in availableLabels"
        :key="label"
        class="checkbox"
        :model-value="selectedValues.includes(label)"
        @update:model-value="() => toggleEnable(label)"
      >
        {{ $t(getLabel ? getLabel(label) : label) }}
      </Checkbox>
    </div>
  </ProductSettingsGenericFilter>
</template>

<script setup lang="ts">
import Checkbox from 'commons/checkbox/Checkbox.vue';
import { computed } from 'vue';
import {
  applyFilters,
  ProductTypeFilters,
} from 'src/app/partnerarea/publishing/detail/productSettings/advanced/filters/productTypeFilters.ts';
import { CompositionSpecificCategoryProductType } from 'commons/composition/compositionCategoryHelper.ts';
import ProductSettingsGenericFilter from './ProductSettingsGenericFilter.vue';

const props = defineProps<{
  heading: string;
  productTypes: CompositionSpecificCategoryProductType[];
  filters: ProductTypeFilters;
  filterKey: keyof ProductTypeFilters;
  getAvailableOptions: (
    productTypes: CompositionSpecificCategoryProductType[],
  ) => string[];
  getLabel?: (key: string) => string;
}>();

const emit = defineEmits<{
  update: [value: string[]];
}>();

const selectedValues = computed<string[]>(
  () => props.filters[props.filterKey] as string[],
);

const availableLabels = computed<string[]>(() => {
  const filteredProductTypes = applyFilters(props.productTypes, {
    ...props.filters,
    [props.filterKey]: [],
  });
  return props.getAvailableOptions(filteredProductTypes);
});

const toggleEnable = (item: string) => {
  const currentValues = selectedValues.value;
  const newValues = currentValues.includes(item)
    ? currentValues.filter((i) => i !== item)
    : [...currentValues, item];

  emit('update', newValues);
};
</script>

<style scoped lang="scss">
@import 'src/scss/styleguide/colors';

.options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  row-gap: 8px;
}

.checkbox {
  text-align: left;
}
</style>
